import { forwardRef } from 'react'

export const inputClasses = (error) =>
    [
        'w-full rounded-none border-2 bg-white dark:bg-zinc-950 px-3 py-2 font-mono text-sm text-black dark:text-white',
        'placeholder:text-zinc-500 dark:placeholder:text-zinc-500',
        'focus:outline-none focus:ring-2 focus:ring-accent',
        'disabled:opacity-50 disabled:cursor-not-allowed transition-colors',
        error ? 'border-red-600 focus:ring-red-600' : 'border-black dark:border-white',
    ].join(' ')

const Input = forwardRef(function Input({ className = '', error, ...props }, ref) {
    return <input ref={ref} className={[inputClasses(error), className].join(' ')} {...props} />
})

export default Input
